import { Component, Inject, ViewEncapsulation } from "@angular/core";
import { MatSnackBarRef, MAT_SNACK_BAR_DATA, MatSnackBarAction, MatSnackBarActions, MatSnackBarLabel } from "@angular/material/snack-bar";
import { ErrorResponse } from "../../../interfaces/error.interface";
import { MatButtonModule } from "@angular/material/button";
import { CommonModule } from "@angular/common";


@Component({
  selector: "app-snackbar-error",
  templateUrl: "./snackbar-error.component.html",
  imports: [CommonModule],
  standalone: true,
})
export class SnackbarErrorComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<SnackbarErrorComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public messages: ErrorResponse[]
  ) {
  }

  close() {
    this.snackBarRef.dismiss();
  }
}
